import React from 'react'
import history from 'app/utils/history'
import { ConnectedRouter } from 'connected-react-router'
import Routes from 'Routes'

const App: React.FC = () => {
  return <ConnectedRouter history={history}>{Routes}</ConnectedRouter>
}

export default App
